import { useState, useEffect } from "react";
import axios from "axios";
import { Container, Table, Spinner } from "react-bootstrap";
import { CSVLink } from "react-csv";
import Pagination from "../Pagination/Pagination";

export default function ListUsers() {
  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  const ls = require("localstorage-ttl");
  const [isLoading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const token = JSON.parse(ls.get("jwt"));

  const PAGE_SIZE = 50;
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState({});
  const [pageUsers, setPageUsers] = useState([]);

  useEffect(() => {
    users.length === 0 ? GetUsers() : FilterUsers(users, currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const headerRequest = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const FilterUsers = (users, page) => {
    setPageUsers(
      users.filter(
        (u, idx) => idx >= (page - 1) * PAGE_SIZE && idx < page * PAGE_SIZE
      )
    );
  };

  const GetUsers = () => {
    setLoading(true);
    axios
      .get(
        `${API_URL}/users?sort[0]=lastname&pagination[pageSize]=2000`,
        headerRequest
      )
      .then((users) => {
        setUsers(users.data);
        setPagination({ total: users.data.length });
        FilterUsers(users.data, 1);
        setLoading(false);
      });
  };

  const renderData = (
    <>
      <Table striped hover size="sm" responsive="sm">
        <thead>
          <tr>
            <th>ID</th>
            <th>DNI</th>
            <th>Apellido</th>
            <th>Nombres</th>
            <th>Email</th>
            <th>Fecha Nac.</th>
            <th>Fecha Ing.</th>
          </tr>
        </thead>
        <tbody>
          {!users || users.length < 1 ? (
            <tr>
              <td colSpan="8" align="center">
                No hay datos.
              </td>
            </tr>
          ) : (
            pageUsers.map((u, index) => (
              <tr key={index}>
                <td align="center">{u.id}</td>
                <td align="center">{u.docNumber}</td>
                <td align="left">{u.lastname}</td>
                <td align="left">{u.name}</td>
                <td align="left">{u.email}</td>
                <td align="center">{u.birthDate}</td>
                <td align="center">{u.startDate}</td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
      <Pagination
        className="pagination-bar"
        currentPage={currentPage}
        totalCount={pagination.total}
        pageSize={PAGE_SIZE}
        onPageChange={(page) => setCurrentPage(page)}
      />
    </>
  );

  return (
    <Container className="p-3 mb-4 bg-light rounded-3">
      <h4>EXPORTAR ALUMNOS</h4>
      {!isLoading && users && users.length > 1 ? (
        <CSVLink
          data={users}
          filename={"faa-users.csv"}
          className="btn btn-success btn-sm"
        >
          DESCARGAR
        </CSVLink>
      ) : null}
      {isLoading ? <Spinner animation="border" /> : renderData}
    </Container>
  );
}
